import { render, staticRenderFns } from "./DownloadAllDocumentsButton.vue?vue&type=template&id=02ed99bc"
import script from "./DownloadAllDocumentsButton.vue?vue&type=script&lang=js"
export * from "./DownloadAllDocumentsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports